import React, {forwardRef, useEffect, useRef, useState} from 'react';
import imagesloaded from "imagesloaded";

function LazyBackgroundImage({Element = 'span', src, className, offset = 100, ...props}, ref) {
    const localRef = useRef();
    const [loadingState, setLoadingState] = useState('initial');
    useEffect(() => {
        let imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let image = entry.target;
                    imageObserver.unobserve(image);
                    setLoadingState('loading')
                }
            });
        }, {
            rootMargin: `0px 0px ${offset}px 0px`
        });
        imageObserver.observe(localRef.current);
        return () => {
            imageObserver.disconnect();
        }
    }, []);
    useEffect(() => {
        if(loadingState === 'loading') {
            if(src) {
                imagesloaded(localRef.current, {background: true}, () => {
                    setLoadingState('loaded');
                })
            }
        }
    }, [loadingState, src])
    return <Element className={`${className} ${loadingState === 'loaded' ? 'img-loaded' : 'img-loading'}`} {...props} ref={el => {
        localRef.current = el;
        if(ref) {
            ref.current = el
        }
    }} style={loadingState !== 'initial' ? {backgroundImage: `url(${src})`} : {}} />
}

export default forwardRef(LazyBackgroundImage)